import React from "react";

class Header extends React.Component {
	render() {
		return (
			<header className="top">
			</header>
		);
	}
}

export default Header; 